function ErrorText({ errorText }: { errorText?: string }) {
  return (
    !!errorText && (
      <div
        data-testid="tax_referral_form_error_text"
        className="text-2 text-red-60"
      >
        {errorText}
      </div>
    )
  );
}

export { ErrorText };
